import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ComingSoon from './ComingSoon';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// The paid app is offline to the public. Only someone already unlocked on /admin
// (same browser tab) gets through; everyone else sees Coming soon.
export default function PaidGate({ children }) {
  const [state, setState] = useState('checking');

  useEffect(() => {
    const password = sessionStorage.getItem('admin_password');
    if (!password) {
      setState('locked');
      return;
    }
    axios
      .get(`${API}/modules`, { headers: { 'X-Admin-Password': password } })
      .then(() => {
        axios.defaults.headers.common['X-Admin-Password'] = password;
        setState('open');
      })
      .catch(() => setState('locked'));
  }, []);

  if (state === 'checking') return <div className="min-h-screen bg-mono-base" data-testid="paid-gate-checking" />;
  if (state === 'locked') return <ComingSoon />;
  return children;
}
